import React from 'react';

const DiamondIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.83293 1.1499L0.37793 4.2399L5.99793 11.4999L11.6179 4.2399L9.16293 1.1499H2.83293Z"
        fill="white"
      />
      <path
        d="M5.99813 11.8899C5.94118 11.8897 5.88501 11.8766 5.8339 11.8514C5.78278 11.8263 5.73806 11.7899 5.70313 11.7449L0.0781307 4.4699C0.0274365 4.40299 0 4.32135 0 4.2374C0 4.15346 0.0274365 4.07181 0.0781307 4.0049L2.53813 0.914902C2.57381 0.871108 2.6188 0.835818 2.66983 0.8116C2.72086 0.787382 2.77664 0.774846 2.83313 0.774903H9.16313C9.21962 0.774846 9.2754 0.787382 9.32644 0.8116C9.37747 0.835818 9.42246 0.871108 9.45813 0.914902L11.9131 3.9999C11.9654 4.06611 11.9939 4.14802 11.9939 4.2324C11.9939 4.31678 11.9654 4.3987 11.9131 4.4649L6.29813 11.7449C6.26171 11.7895 6.21599 11.8255 6.16417 11.8506C6.11235 11.8756 6.05568 11.8891 5.99813 11.8899ZM0.853131 4.2449L5.99813 10.8999L11.1431 4.2449L8.96313 1.5249H3.01313L0.853131 4.2449Z"
        fill="#36354C"
      />
      <path
        d="M3.05814 1.49463L1.72314 4.23963H4.84814L3.05814 1.49463Z"
        fill="#FCC2D7"
      />
      <path
        d="M5.99805 10.9047L10.283 4.23975H7.13305L5.99805 10.9047Z"
        fill="#FCC2D7"
      />
      <path
        d="M8.46293 4.61475H0.37793C0.278473 4.61475 0.183091 4.57524 0.112765 4.50491C0.0424385 4.43459 0.00292969 4.3392 0.00292969 4.23975C0.00292969 4.14029 0.0424385 4.04491 0.112765 3.97458C0.183091 3.90426 0.278473 3.86475 0.37793 3.86475H8.46293C8.56239 3.86475 8.65777 3.90426 8.7281 3.97458C8.79842 4.04491 8.83793 4.14029 8.83793 4.23975C8.83793 4.3392 8.79842 4.43459 8.7281 4.50491C8.65777 4.57524 8.56239 4.61475 8.46293 4.61475Z"
        fill="#36354C"
      />
    </svg>
  );
};

export default DiamondIcon;
